import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonSlides, ToastController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { Dashboard } from '../models/dashboard';
import { HttpClient } from '@angular/common/http';
import { SubscriptionService } from '../services/subscription.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  @ViewChild('slides', { static: true }) slider: IonSlides;
  segment = 0;
  dashboard: Dashboard;
  wifiData: any = {};
  
  // Account data - placeholder values, wire to API later
  accountData = {"passname":"netpap","points":0.0,"wallet":0.0,"messages_count":[],"invoice_id":"","next_due_date":"n/a","subscription":"n/a","subscription_amount":0,"outstanding_balance":0.0,"invoices":0,"user_type":"","station":"-","is_prepaid":1,"router_domain_name":"http://10.10.0.1/ok.html","subject":"Notification","message":"Welcome dear customer,We appreciate your time.This is the noticeboard/area.Please look around and feel at home"}
  
  unreadMessages = 3; // Placeholder - wire to API

  constructor(
    private authService: AuthenticationService,
    private subsService:SubscriptionService,
    private toastController:ToastController,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.dashboard = this.authService.getUserDetails();
    console.log(this.dashboard, '--- Dashboard loaded ---');
    
    // TODO: Load account data from API
    this.subsService.fetchUserInfo().subscribe(data=>{
      this.accountData = data
      this.subsService.setData(data)
      console.log(data)
    })
  }


  open(endpoint: string) {
    this.router.navigate(['/client/' + endpoint]);
  }

  async segmentChanged(ev: any) {
    console.log(ev);
    if (this.slider) {
      await this.slider.slideTo(this.segment);
    }
  }

  async slideChanged() {
    if (this.slider) {
      this.segment = await this.slider.getActiveIndex();
      console.log(this.segment);
    }
  }

  logout() {
    this.authService.logout();
  }

  payNow(payment_method:string) {
    if(this.accountData?.points <=0 && payment_method =="redeem"){
      console.log("points zero")
      this.presentToast("You dont have points to redeem")
      return true;
    }
    if (payment_method =="redeem"){
      this.router.navigate([`/client/payment`,payment_method, this.accountData?.user_type]);
    }else{
      this.router.navigate([`/client/renew`,payment_method, this.accountData?.user_type,this.accountData?.invoice_id]);
    }
  }
  async presentToast(message: string) {
  const toast = await this.toastController.create({
    message,
    duration: 4000, // milliseconds
    position: 'bottom'
  });
  await toast.present();
}
}
